function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import PropTypes from 'prop-types';
import Input from './Input';
import AccessibilityVision from '../Icons/AccessibilityVision';
import Hide from '../Icons/Hide';
var PasswordInput = forwardRef(function (props, ref) {
  var _useState = useState(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var isInitialMount = useRef(true);
  var inputRef = useRef(null);
  useImperativeHandle(ref, function () {
    return inputRef.current;
  });

  var onKeyUp = function onKeyUp(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      setVisible(!visible);
    }
  };

  useEffect(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      var _inputRef$current;

      var icon = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.nextSibling.querySelector('svg');

      if (icon) {
        try {
          icon.focus();
        } catch (err) {
          inputRef.current.focus();
        }
      }
    }
  }, [visible]);
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    ref: inputRef,
    type: visible ? 'text' : 'password',
    icon: visible ? AccessibilityVision : Hide,
    iconAttrs: _extends({}, props.iconAttrs, {
      role: 'button',
      'aria-label': (visible ? 'cacher' : 'afficher') + " le mot de passe",
      onKeyUp: onKeyUp
    }),
    onIconClick: function onIconClick() {
      return setVisible(!visible);
    },
    autoComplete: "off"
  }));
});
PasswordInput.propTypes = process.env.NODE_ENV !== "production" ? {
  iconAttrs: PropTypes.shape({})
} : {};
PasswordInput.defaultProps = {
  iconAttrs: undefined
};
export default PasswordInput;